import { ThisStepContext } from 'ecp/app/Proposals/components/ProposalSteps/ProposalSteps'
import { useContext } from 'react'

const useThisStep = () => useContext(ThisStepContext)
export default useThisStep
